import one from './one.vue'
import two from './two.vue'
import three from './three.vue'

export default {
	one,
	two,
	three
}


// WEBPACK FOOTER //
// ./src/components/template/mod/index.js